import type { CommunicationsInsightsGranularity } from '../../../services/communicationsInsights';
import { GranularityToggle, type GranularityOption } from '../GranularityToggle';

const OPTIONS: GranularityOption<CommunicationsInsightsGranularity>[] = [
    { key: 'day', label: 'Day' },
    { key: 'week', label: 'Week' },
    { key: 'month', label: 'Month' }
];

interface CommunicationsGranularityToggleProps {
    value: CommunicationsInsightsGranularity;
    onChange: (next: CommunicationsInsightsGranularity) => void;
}

// Drives the shared granularity state behind all three Accounts Overview
// analytics cards (see AccountsOverview.tsx).
export function CommunicationsGranularityToggle({
    value,
    onChange
}: CommunicationsGranularityToggleProps) {
    return (
        <GranularityToggle
            value={value}
            onChange={onChange}
            options={OPTIONS}
            ariaLabel="Communications insights granularity"
        />
    );
}
